const tokenFCMInitialState = {
  tokenFCM: {
    loading: false,
    error: null,
    data: null,
    newToken: null,
  },
};

export default tokenFCMInitialState;
